import { Button, Typography } from '@mui/material'
import * as React from 'react'
import { ICourse, ICourseLessonContent } from '../../../interfaces/ICourse'
import { ISchool } from '../../../interfaces/school.interface'
import { IUserDetails } from '../../../interfaces/user.interface'
import { IPaymentsPlan } from '../../../interfaces/IPaymentsPlan'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'

function isTeacherAssignedToCourseFunc(
  courseDetails: ICourse,
  teacherId: string,
): boolean {
  console.log('courseDetails', courseDetails)
  return courseDetails?.teachers?.map(t => t?._id).includes(teacherId)
}

interface ITeacherCourseDetailsProps {
  schoolDetailsFromCourse: ISchool
  courseDetails: ICourse
  userDetails: IUserDetails
  courseLessonContents: Array<ICourseLessonContent>
  paymentPlans: IPaymentsPlan[]
}

export default function TeacherCourseDetailsActionButton(
  props: ITeacherCourseDetailsProps,
) {
  const [
    isTeacherAssignedToCourse,
    setIsTeacherAssignedToCourse,
  ] = React.useState<boolean>(false)

  React.useEffect(() => {
    setIsTeacherAssignedToCourse(
      isTeacherAssignedToCourseFunc(props.courseDetails, props.userDetails._id),
    )
  }, [props.courseDetails._id, props.userDetails._id])

  const class_url = `/courses/content/${props.courseDetails._id}`

  return (
    <div style={{ width: '100%' }}>
      {isTeacherAssignedToCourse || props.userDetails?.user_type === 'admin' ? (
        <Button
          style={{ height: '50px' }}
          variant="contained"
          disableElevation={true}
          fullWidth={true}
          href={class_url}
          color="primary"
        >
          Open class <ArrowForwardIcon style={{ marginRight: '5px' }} />
        </Button>
      ) : (
        <div>
          {props.userDetails.user_type === 'teacher' && (
            <Typography gutterBottom={true} variant="body2" color="error">
              You are not assigned to this course, please contact the admin for
              more information
            </Typography>
          )}
          <Button
            style={{ height: '50px' }}
            variant="contained"
            disableElevation={true}
            fullWidth={true}
            href={'/dashboard'}
            color="primary"
          >
            GO TO DASHBOARD
          </Button>
        </div>
      )}
    </div>
  )
}
